import {useDispatch} from "react-redux";
import {useEffect} from "react";
import {deleteModal, setModal} from "../redux/slices/layoutSlice";

export const useModalDisable = (modalId, isVisible) => {

  const dispatch = useDispatch();

  useEffect(() => {
    if (isVisible) {
      dispatch(setModal({modal: modalId}));
    } else {
      dispatch(deleteModal({modal: modalId}));
    }

    return () => {
      dispatch(deleteModal({modal: modalId}));
    };
  }, [dispatch, modalId, isVisible]);
};